import { render, staticRenderFns } from "./InvestmentCalculator.vue?vue&type=template&id=1c48b97e&scoped=true&"
import script from "./InvestmentCalculator.vue?vue&type=script&lang=js&"
export * from "./InvestmentCalculator.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentCalculator.vue?vue&type=style&index=0&id=1c48b97e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48b97e",
  null
  
)

export default component.exports